module.exports = __webpack_public_path__ + "media/images/pages/team-8-e2284e98f6b3bfe8a8c4c4576c194155.jpg";